import { http } from '../../config/axios'

export default function putPerfil(perfil: any): Promise<string> {
  return http
    .put('api/perfil', perfil)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put perfil', error)
      throw Error(error.response.data)
    })
}
